<template>
  <RevInfoBlock
    :icon="IconLightbulb"
    :title="i18n(translations.title)"
    variant="info"
  >
    <div>{{ i18n(translations.content) }}</div>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconLightbulb } from '@ds/icons/IconLightbulb'

import translations from './Tips.translations'

const i18n = useI18n()
</script>
